import { FetchRequestError } from "./FetchRequestError";

export class FetchInvalidJsonError extends FetchRequestError {}
